// src/components/ui/Countdown.jsx

import React, { useState, useEffect } from "react";
import { formatTimeRemaining } from "@/lib/formatTimeRemaining";

/**
 * Countdown component that displays a live-updating timer until a given deadline.
 * - Usage: <Countdown deadline={someDateStringOrISO} />
 * - The timer updates every second and displays "Ended" if deadline has passed.
 */
const Countdown = ({ deadline }) => {
  const [time, setTime] = useState(formatTimeRemaining(deadline));

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatTimeRemaining(deadline));
    }, 1000);
    return () => clearInterval(interval);
  }, [deadline]);

  return <span>{time}</span>;
};

export default Countdown;